export const Capabilities = {
  mobile: require('./capabilities/mobile-app.json'),
  web: require('./capabilities/website.json'),
  uiux: require('./capabilities/uiux-design.json'),
  project: require('./capabilities/project.json'),
}

export const Contact = {
  email: require('./contact/email.json'),
  mobile: require('./contact/mobile.json'),
}

export const Hero = {
  wavingHand: require('./hero/wavingHand.json'),
}
